module.exports = __webpack_public_path__ + "img/mail-w.c650ca79.svg";